import React from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  useMenuState,
} from '@twilio-paste/core/menu';
import { Box } from '@twilio-paste/core/box';
import { Text } from '@twilio-paste/core/text';
import { LinkExternalIcon } from '@twilio-paste/icons/esm/LinkExternalIcon';
import { SupportIcon } from '@twilio-paste/icons/esm/SupportIcon.js';
import { content } from '../content';
import {
  sendgridPreferencesPath,
  setupGuidePath,
  supportUrl,
} from '../constants';

export const SupportMenu: React.FC = () => {
  const menu = useMenuState();

  return (
    <>
      <MenuButton
        {...menu}
        variant="secondary_icon"
        baseId="support-menu"
        size="reset"
      >
        <SupportIcon decorative={false} title="Support action options" />
      </MenuButton>
      <Menu {...menu} aria-label="Support" tabIndex={-1}>
        <MenuItem {...menu}>
          <Text as="a" href={supportUrl} target="_blank">
            <Box display="flex" justifyContent="space-between">
              {content.helpAndSupport}
              <LinkExternalIcon decorative={false} title="" />
            </Box>
          </Text>
        </MenuItem>
        <MenuItem {...menu}>
          <Text as="a" href={sendgridPreferencesPath} target="_blank">
            <Box display="flex" justifyContent="space-between">
              {content.sendgridPreferences}&nbsp;&nbsp;
              <LinkExternalIcon decorative={false} title="" />
            </Box>
          </Text>
        </MenuItem>
        <MenuItem {...menu}>
          <Text as="a" href={setupGuidePath} target="_blank">
            <Box display="flex" justifyContent="space-between">
              {content.setupGuide}
              <LinkExternalIcon decorative={false} title="" />
            </Box>
          </Text>
        </MenuItem>
      </Menu>
    </>
  );
};
